<template>
    <div :class="wrapperClass">
        <label :for="selectId">{{ label }}</label>
        <select
            :id="selectId"
            :value="selectedValue"
            @change="onChange"
            class="form-select input-air-primary"
            :disabled="disabled">
            <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
            <option
                v-for="item in items"
                :key="itemKey(item)"
                :value="itemValue(item)">
                {{ itemLabel(item) }}
            </option>
        </select>
    </div>
</template>
<script>
export default {
    name: 'SelectBox',
    props: {
        selectId: String,
        label: String,
        items: Array,
        itemKey: {
            type: Function,
            default: item => item.id
        },
        itemValue: {
            type: Function,
            default: item => item.id
        },
        itemLabel: Function,
        selectedValue: [String, Number],
        placeholder: String,
        disabled: Boolean,
        wrapperClass: {
            type: String,
            default: 'mb-3',
        }
    },
    emits: ['update:selectedValue'],
    methods: {
        onChange(event) {
            this.$emit('update:selectedValue', event.target.value);
        }
    }
}
</script>

<style scoped></style>
